/* eslint-disable ish-custom-rules/require-formly-code-documentation */
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  viewChild,
} from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { ImageMapper } from 'ish-core/models/image/image.mapper';
import { CustomSuggestTerm } from 'ish-core/models/suggest-term/custom-suggest-term.model';

@Component({
  selector: 'custom-quickorder-search-field',
  templateUrl: './custom-quickorder-search-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomQuickorderSearchFieldComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy, AfterViewInit
{
  readonly input = viewChild<ElementRef<HTMLInputElement>>('searchInput');
  textInputFieldTypes = ['text'];

  inputSearchTerms$ = new ReplaySubject<string>(1);
  productSearchResults$ = new ReplaySubject<CustomSuggestTerm[]>(1);
  activeIndex = -1;
  inputFocused: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private shoppingFacade: ShoppingFacade,
    private cdRef: ChangeDetectorRef,
    private imageMapper: ImageMapper
  ) {
    super();
  }
  ngOnInit() {
    this.inputSearchTerms$.next('');
    this.shoppingFacade
      .getSearchResult$(this.inputSearchTerms$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.productSearchResults$.next(data);
      });
  }
  ngAfterViewInit() {
    // this.input is NOW valid !!
    this.activeIndex = -1;
  }
  blur() {
    this.inputFocused = false;
    this.activeIndex = -1;
  }
  focus() {
    this.inputFocused = true;
  }

  selectSuggestedTerm(index: number) {
    //selection with keyboard
    this.productSearchResults$.pipe(take(1), takeUntil(this.destroy$)).subscribe(results => {
      if (index < -1 || index > results.length - 1) {
        return;
      }
      this.activeIndex = index;
    });
  }

  searchSuggest(source: string | EventTarget) {
    //triggers search only after 2 characters
    const searchTerm = typeof source === 'string' ? source : (source as HTMLDataElement).value;
    if (searchTerm.length > 2) {
      this.inputSearchTerms$.next(searchTerm);
    }
  }

  submitSearch(suggestedTerm: string) {
    if (!suggestedTerm) {
      return false;
    }
    const inputElement: HTMLInputElement = this.input().nativeElement as HTMLInputElement;
    if (this.activeIndex !== -1) {
      this.productSearchResults$.pipe(take(1), takeUntil(this.destroy$)).subscribe(results => {
        if (inputElement.value !== results[this.activeIndex]?.id) {
          // // something was selected via keyboard
          // inputElement.value = results[this.activeIndex].id;
          // //triggers input and blur the field
          // inputElement.dispatchEvent(new InputEvent('input'));
          // inputElement.dispatchEvent(new Event('blur'));
          // this.cdRef.detectChanges();
          // // remove focus on the field
          this.formControl.setValue(results[this.activeIndex].id, { emitEvent: true });

          inputElement.dispatchEvent(new Event('blur'));
          this.cdRef.detectChanges();
          this.activeIndex = -1;
        }
      });
      this.inputFocused = false;
    } else {
      this.formControl.setValue(suggestedTerm, { emitEvent: true });
      inputElement.dispatchEvent(new Event('blur'));
      this.inputFocused = false;
    }
  }

  onPopulate(field: FormlyFieldConfig) {
    if (!field.props?.type) {
      field.props.type = 'text';
      return;
    }

    if (!this.textInputFieldTypes.includes(field.props.type)) {
      throw new Error(
        'parameter <templateOptions.type> is not valid for TextInputFieldComponent, only text, email, password and tel are possible values'
      );
    }
  }

  getImageUrl(imageUrl: CustomSuggestTerm) {
    return imageUrl?.image.startsWith('https://')
      ? imageUrl?.image
      : this.imageMapper.fromEffectiveUrl(imageUrl?.image);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
